import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import Pagination from "../common/Pagination";
import { BiEditAlt } from "react-icons/bi";
import { IoEyeOutline } from "react-icons/io5";
import EntityModal from "./EntityModal";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";

const EntityIDs = ({ openModal, customerCode, name }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const loggedInUserCode = sessionStorage.getItem("userCode");
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize] = useState(10);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [modalType, setModalType] = useState("");
  const { user } = useSelector((state) => state.auth);

  const handleViewEntity = (entity, type) => {
    setSelectedEntity({
      name: entity?.entityName,
      id: entity?.entityId,
      username: entity?.name,
    });
    setModalType(type);
    setOpenPopup(true);
  };

  const handleClose = () => setOpenPopup(false);

  const handleShowTable = async () => {
    setShowTable(true);
    setLoading(true);
    await fetchEntitydata(1);
  };

  const fetchEntitydata = async (page) => {
    const data = {
      username: loggedInUserName,
      userCode: customerCode,
    };

    try {
      const response = await axiosPostApi(
        `${apiList.DLT_FETCH_ENTITY}?pageSize=${pageSize}&pageNo=${page}`,
        data
      );
      setEntities(response?.data?.data || []);
      setPageDetails(response?.data?.pageDetails || null);
    } catch (error) {
      console.error("Failed to fetch entity data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    openModal();
    setShowTable(false);
  };

  const pageSizeCount = pageDetails ? pageDetails.pageSize : 0;
  const totalRecord = pageDetails ? pageDetails.totalRecords : 0;

  const getActionItems = (entity) => {
    const actions = [];

    if (user?.data?.userRole === "ADMK") {
      actions.push({
        icon: <BiEditAlt style={{ marginRight: "10px" }} />,
        label: "Edit",
        onClick: (e) => {
          e.stopPropagation();
          handleViewEntity(entity, "modify");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleViewEntity(entity, "view");
      },
    });

    return actions;
  };

  return (
    <div className="entity-ids-container">
      <div className="d-flex first-tab-controls">
        <div className="d-flex gap-3"></div>
        <div className="d-flex gap-3">
          <button
            className="btn addUser"
            onClick={handleShowTable}
            disabled={showTable}
            style={{
              backgroundColor: showTable ? "#80d7e1" : "",
              color: showTable ? "#ffffff" : "",
            }}
          >
            Show Entity ID
          </button>
          {(user?.data?.userRole === "ADMK" || (user?.data?.userRole === "PARTNER" && loggedInUserCode !== customerCode)) && (
            <button className="btn addUser" onClick={handleSwitch}>
              + Add Entity ID
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        showTable && (
          <div className="table-container">
            {entities.length > 0 ? (
              <>
                <div className="table-wrapper">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Status</th>
                        <th>Entity ID</th>
                        <th>Entity Name</th>
                        <th>Created Date-Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {entities.map((entity) => (
                        <tr key={entity.id}>
                          <td className="actions" style={{ overflow: "visible" }}>
                            <Popover>
                              {({ open, close }) => (
                                <>
                                  <Popover.Button
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      display: "inline-block",
                                      padding: "0 10px",
                                      background: "none",
                                      border: "none",
                                    }}
                                  >
                                    ⋮
                                  </Popover.Button>
                                  <Transition
                                    as={React.Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                  >
                                    <Popover.Panel
                                      style={{
                                        position: "absolute",
                                        zIndex: 2000,
                                        minWidth: "220px",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "8px",
                                        padding: "8px 0",
                                        overflow: "visible",
                                      }}
                                    >
                                      {getActionItems(entity).map((action, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 20px",
                                            cursor: "pointer",
                                            color: "#333",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            transition: "background-color 0.2s",
                                            whiteSpace: "nowrap",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#f0f0f0")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#ffffff")
                                          }
                                          onClick={(e) => {
                                            action.onClick(e);
                                            close();
                                          }}
                                        >
                                          {action.icon}
                                          <span>{action.label}</span>
                                        </div>
                                      ))}
                                    </Popover.Panel>
                                  </Transition>
                                </>
                              )}
                            </Popover>
                          </td>
                          <td>
                            <span
                              className="status"
                              style={{
                                color: entity.entityStatus === "ACTIVE" ? "#55cd69" : "#fb4a3f",
                              }}
                            >
                              {entity.entityStatus}
                            </span>
                          </td>
                          <td>{entity?.entityId || "-"}</td>
                          <td>{entity?.entityName || "-"}</td>
                          <td>{entity?.entityDate || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    totalCount={totalRecord}
                    pageSize={pageSizeCount}
                    onPageChange={(page) => {
                      setCurrentPage(page);
                      fetchEntitydata(page);
                    }}
                  />
                </div>
              </>
            ) : (
              <p className="no-data-message">No data available</p>
            )}
          </div>
        )
      )}
      <EntityModal
        show={openPopup}
        handleClose={handleClose}
        customerCode={customerCode}
        name={name}
        entityDetails={selectedEntity}
        modalType={modalType}
        handleShowTable={handleShowTable}
      />
    </div>
  );
};

export default EntityIDs;